/**
 *
 * ResetPassword
 *
 */
import React, { memo, useRef } from 'react';
import { BoxDesign, Input, NewButton, Modal } from '../AlltypeStyledComponent';
import { P } from '../AtomComponents/P';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from 'utils/hooks/useMediaQuery';
import api from 'app/api';
import { receiveError, successModal } from 'utils/showSuccessErrorModal';
import { ErrorInterface } from 'utils/types/success-error-types';

export const ResetPassword = memo(() => {
  const isMobile = useMediaQuery('(max-width: 500px)');
  const email = useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();

  const onSubmit = async e => {
    e.preventDefault();
    const values = {
      email: email.current?.value ? email.current.value.toLowerCase() : '',
    };
    try {
      const response = await api.post(
        `/auth/business-employees/create-token`,
        { email: values.email },
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      );

      if (response.status === 200) {
        successModal('Reset password link sent to your email');
        navigate('/');
      } else {
        alert('Error sending reset password link');
      }
    } catch (error) {
      const apiError = error as ErrorInterface;
      receiveError(apiError?.response?.data ?? apiError?.message ?? apiError);
    }
  };

  return (
    <Modal background='var(--heltar-bg-primary)'>
      <BoxDesign
        padding='50px'
        fontsize='16px'
        width={isMobile ? 'calc(100% - 15px)' : '500px'}
        style={{
          maxHeight: 'calc(var(--app-height, 100vh) - 80px)',
          overflowY: 'auto',
          margin: '65px 0 0 0',
        }}
      >
        <form action='' onSubmit={onSubmit}>
          <label htmlFor='email'>
            <P fontsize='18'>Enter your Email to Reset Password:</P>
          </label>
          <Input
            type='email'
            placeholder='Enter Email'
            width={isMobile ? '90%' : '380px'}
            margin='15px 0'
            required
            ref={email}
          />
          <br />
          <NewButton type='submit' margintop='10px' width='150px' height='40px'>
            Submit
          </NewButton>
        </form>
      </BoxDesign>
    </Modal>
  );
});
